import type { InternalRoomState } from '../../types/infrastructure.types'
import type { PublicActiveGame, PublicRoomState } from '../../types/room.types'
import { DEFAULT_HOST_TERM, hostPlaysByGameIdOf } from '../hosting/hosting'

/**
 * Convert internal active game state into the public room-state shape.
 *
 * Game state remains client-local and is intentionally never serialized.
 */
export function serializeActiveGame(activeGame: InternalRoomState['activeGame']): PublicActiveGame | null {
  if (!activeGame) return null

  return {
    gameId: activeGame.gameId,
    startedAt: activeGame.startedAt,
    gameOptions: activeGame.gameOptions,
    challengeConfiguration: activeGame.challengeConfiguration,
    managed: activeGame.managed,
    mateIDs: activeGame.mateIDs,
    mateSlotMap: activeGame.mateSlotMap,
    observerIDs: activeGame.observerIDs,
    mateGroups: activeGame.mateGroups,
    playerIds: activeGame.playerIds,
    channel: activeGame.channel,
    gameVersion: activeGame.gameVersion,
    seed: activeGame.seed,
    actions: activeGame.actions,
  }
}

/**
 * Convert internal room state into the public room-state shape.
 */
export function serializeRoomState(state: InternalRoomState): PublicRoomState {
  return {
    activeGame: serializeActiveGame(state.activeGame),
    gameSetup: state.gameSetup,
    mates: state.mates,
    createdAt: state.createdAt,
    gameless: state.gameless ?? false,
    hostMateIds: state.hostMateIds ?? [],
    managed: state.managed ?? false,
    hostTerm: state.hostTerm ?? DEFAULT_HOST_TERM,
    hostPlaysByGameId: hostPlaysByGameIdOf(state),
    curated: state.curated ?? false,
    curatedGameIds: state.curatedGameIds ?? [],
  }
}
